<script setup lang="ts">
import { useI18n } from "vue-i18n";

import NoSchedulesImage from "@/Assets/images/empty-schedule.svg";

const { t } = useI18n();
</script>

<template>
  <div class="empty">
    <img class="empty__image" :src="NoSchedulesImage" :alt="t('appointments.empty_list')" />

    <p class="empty__title">
      {{ t("appointments.empty_list") }}
    </p>
  </div>
</template>

<style scoped lang="scss">
.empty {
  @include sp.padding(r, 5);

  display: flex;
  flex-direction: column;
  flex-grow: 1;
  align-items: center;

  &__title {
    @include sp.margin(t, 5);
    @include text.general(low, xl);
    @include colors.color(content, mid);
    @include text.modification(center);
  }

  &__image {
    @include sp.margin(t, 6);

    width: $space-20;
  }
}
</style>
